import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';

import { Tabs } from '../component/Tabs';
import { Dropdown } from '../component/Dropdown';
import { DayPickerYMD } from '../component/DayPicker';
import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';

import { BWStepBar } from '../component/BWStepBar';
import { BWReceipt } from '../component/BWReceipt';

import translateBase from '../../translate';
let translate = translateBase.bindPage('forgottenPassword');

function ffProps(form, fieldName) {
    return {
        value: form.computedRawValues[fieldName],
        onChange: event => form.commitValue(fieldName, event.target.value),
        onBlur: () => form.handleBlur(fieldName),
    }
}

@observer
class Validations extends React.Component {
    render() {
        const { form, fieldName } = this.props;
        return <div className="validations">
            <ul>
                {/*form.validations[fieldName].map(val =>
                    <li>{val}</li>
                )*/}
            </ul>
        </div>
    }
}

@inject(stores => ({
    flasher: stores.app.flasher,
    navigation: stores.app.navigation,
    vForgottenPassword: stores.app.vForgottenPassword,
    passwordRecoveryEmailForm: stores.app.passwordRecoveryEmailForm,
    passwordRecoveryPasswordForm: stores.app.passwordRecoveryPasswordForm,
}))
@observer
export class ForgottenPassword extends React.Component {
    refLinkInput = (element) => {
        this.linkInput = element;
    }

    render() {
        const { flasher, navigation, vForgottenPassword, passwordRecoveryEmailForm, passwordRecoveryPasswordForm, step } = this.props;
        //const currency = "CHF";

        return (
            <div>
                <SiteHeader />

                {step === '1' &&
                    <section className="passwordForgotten-container">
                        <div className="wrapper">
                            <div className="row">
                                <div className="column-12">
                                    <h3 className="mali-blue">{translate("resetPassword", "Passwort zurücksetzen")}</h3>
                                    <div className="password-container">
                                        <div className="row">
                                            <h4>{translate("enterEmailAddress", "Bitte geben Sie die E-Mail Adressen ein, die Sie für die Registrierung verwendet haben.")}</h4>
                                        </div>
                                        <div className="row">
                                            <div className="label">
                                                {translate("yourEmailAddress", "Ihre E-Mail Adresse")}
                                            </div>
                                            <div className="input">
                                                <input type="email" {...ffProps(passwordRecoveryEmailForm, 'email')} />
                                            </div>
                                            <Validations form={passwordRecoveryEmailForm} fieldName="email" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row passwordForgottenBtns-container">
                                <div className="column-3 offset-3">
                                    <a className="back" onClick={navigation.goHome}><i className="fa fa-times" aria-hidden="true"></i> {translate("cancel", "Abbrechen")}</a>
                                </div>
                                <div className="column-3">
                                    <a className="forward" onClick={vForgottenPassword.sendEmail}>{translate("sendEmail", "E-Mail senden")}<i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                {step === '2' &&
                    <section className="passwordForgotten-container">
                        <div className="wrapper">
                            <div className="row">
                                <div className="column-12">
                                    <h3 className="mali-blue">{translate("forgotPasswordEmail", "Passwort-Vergessen E-Mail")}</h3>
                                    <div className="password-container">
                                        <div className="row">
                                            <h4>{translate("weHaveSentEmail", "Wir haben eine E-Mail mit einem Link zur Passwort-Wiederherstellung an ${email} gesandt. Bitte öffnen Sie die E-Mail und klicken Sie auf den Link zur Passwort-Wiederherstellung.", { email: vForgottenPassword.email })}</h4>
                                        </div>
                                        {/*<div className="row">
                                    TEST LINK RECEIVED BY EMAIL: <input type="text" ref={this.refLinkInput} />
                                    <button onClick={() => vForgottenPassword.interpretLink(this.linkInput.value)}>Go</button>
                                </div>*/}
                                    </div>
                                </div>
                            </div>
                            <div className="row passwordForgottenBtns-container">
                                <div className="column-3 offset-3">
                                    {/*<a className="back" onClick={navigation.goHome}><i className="fa fa-arrow-left" aria-hidden="true"></i> Home</a> */}
                                </div>
                                <div className="column-3">
                                    <a className="forward" onClick={navigation.goHome}>{translate("Home", "Startseite")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                {step === '3' &&
                    <section className="passwordForgotten-container">
                        <div className="wrapper">
                            <div className="row">
                                <div className="column-12">
                                    <h3 className="mali-blue">{translate("resetPassword", "Passwort zurücksetzen")}</h3>
                                    <div className="password-container">
                                        <div className="row">
                                            <h4>{translate("enterNewPassword", "Geben Sie Ihr neues Passwort ein und bestätigen Sie es.")}</h4>
                                        </div>
                                        <div className="row">
                                            <div className="label">
                                                {translate("username", "Benutzername")}
                                            </div>
                                            <div className="input">
                                                <input type="text" disabled value={vForgottenPassword.userName} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="label">
                                                {translate("newPassword", "Neues Passwort")}
                                            </div>
                                            <div className="input">
                                                <input type="password" {...ffProps(passwordRecoveryPasswordForm, 'password1')} />
                                                <p>{translate("passwordComplexityDesc", "Mindestens 7 alphanumerische Zeichen und ein Sonderzeichen")}</p>
                                            </div>
                                            <Validations form={passwordRecoveryPasswordForm} fieldName="password1" />
                                        </div>
                                        <div className="row">
                                            <div className="label">
                                                {translate("repeatNewPassword", "Neues Passwort wiederholen")}
                                            </div>
                                            <div className="input">
                                                <input type="password" {...ffProps(passwordRecoveryPasswordForm, 'password2')} />
                                            </div>
                                            <Validations form={passwordRecoveryPasswordForm} fieldName="password2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row passwordForgottenBtns-container">
                                <div className="column-3 offset-3">
                                    {/*<a className="back" onClick={navigation.goHome}><i className="fa fa-arrow-left" aria-hidden="true"></i> Home</a> */}
                                </div>
                                <div className="column-3">
                                    <a className="forward" onClick={vForgottenPassword.setPassword}>{translate("save", "Speichern")} <i className="fa fa-floppy-o" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                {step === '4' &&
                    <section className="passwordForgotten-container">
                        <div className="wrapper">
                            <div className="row">
                                <div className="column-12">
                                    <h3 className="mali-blue">{translate("resetSuccessTitle", "Passwort erfolgreich zurückgesetzt")}</h3>
                                    <div className="password-container">
                                        <div className="row">
                                            <h4>{translate("resetSuccessDesc", "Ihr Passwort wurde erfolgreich neu gesetzt. Bitte gehen Sie zur Startseite und melden sich an.")}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row passwordForgottenBtns-container">
                                <div className="column-3 offset-3">
                                    {/*<a className="back" onClick={navigation.goHome}><i className="fa fa-arrow-left" aria-hidden="true"></i> Home</a> */}
                                </div>
                                <div className="column-3">
                                    <a className="forward" onClick={navigation.goHome}>{translate("Home", "Startseite")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                <SiteFooter />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/visual/view/ForgottenPassword.js